import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LinkIcon from '@mui/icons-material/Link';
import BalanceIcon from '@mui/icons-material/Balance';
import PercentIcon from '@mui/icons-material/Percent';
import PieChartIcon from '@mui/icons-material/PieChart';
import ShieldIcon from '@mui/icons-material/Shield';
import SportsFootballIcon from '@mui/icons-material/SportsFootball';
import NumbersIcon from '@mui/icons-material/Numbers';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SearchIcon from '@mui/icons-material/Search';
import SchoolIcon from '@mui/icons-material/School';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CalculateIcon from '@mui/icons-material/Calculate';
import PeopleIcon from '@mui/icons-material/People';
import TuneIcon from '@mui/icons-material/Tune';
import SpeedIcon from '@mui/icons-material/Speed';
import RadarIcon from '@mui/icons-material/Radar';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';

const ICON_MAP = {
	SwapHoriz: SwapHorizIcon,
	FilterAlt: FilterAltIcon,
	TrendingUp: TrendingUpIcon,
	AccountBalance: AccountBalanceIcon,
	Link: LinkIcon,
	Balance: BalanceIcon,
	Percent: PercentIcon,
	PieChart: PieChartIcon,
	Shield: ShieldIcon,
	SportsFootball: SportsFootballIcon,
	Numbers: NumbersIcon,
	FormatListBulleted: FormatListBulletedIcon,
	AccountBalanceWallet: AccountBalanceWalletIcon,
	Search: SearchIcon,
	School: SchoolIcon,
	ShoppingCart: ShoppingCartIcon,
	Calculate: CalculateIcon,
	People: PeopleIcon,
	Tune: TuneIcon,
	Speed: SpeedIcon,
	Radar: RadarIcon,
	CompareArrows: CompareArrowsIcon,
};

export default ICON_MAP;
